<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loadingSpinner">
      <b-spinner
        variant="success"
        label="Spinning"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <div v-if="!loadingSpinner">
      <b-card class="my-2">
        <b-row>
          <b-col>
            <h2 class="text-primary m-0 p-0">Product manufactured inhouse?</h2>
          </b-col>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-start my-1"
          >
            <label for="check-button" class="mr-2 text-primary">No</label>
            <b-form-checkbox
              name="check-button"
              switch
              inline
              v-model="product.inHouseManufactured"
              disabled
            >
            </b-form-checkbox>
            <label for="check-button" class="text-primary">Yes</label>
          </b-col>
          <b-col>
            <h3></h3>
          </b-col>
        </b-row>
      </b-card>
      <form-wizard
        color="#B1D06C"
        :title="null"
        :subtitle="null"
        shape="square"
        finish-button-text="Finish"
        back-button-text="Previous"
        class="mb-3"
        @on-complete="formSubmitted"
        ref="formWiz"
        v-if="product.inHouseManufactured == true"
      >
        <!-- Search details tab -->
        <tab-content title="Details">
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group label="Product Name" label-for="mc-Product-name">
                  <b-form-input
                    id="mc-Product-name"
                    type="text"
                    v-model="product.name"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Product classification"
                  label-for="mc-Product-name"
                >
                  <b-form-input
                    id="mc-Product-name"
                    type="text"
                    :value="getTypeNameById(product.type)"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
        <b-form-group label="Enable Ecommerce" label-for="mc-Product-Ecomm">
          <b-form-checkbox
            checked="false"
            v-model="product.isEcomm"
            name="check-button"
            switch
            inline
            disabled
          >
          </b-form-checkbox>
        </b-form-group>
      </b-col>

              <b-col md="4">
                <b-form-group label="Product Code" label-for="mc-Product-Code">
                  <b-form-input
                    id="mc-Product-Code"
                    type="text"
                    v-model="product.code"
                    readonly
                  />
                </b-form-group>
              </b-col>

              

              <b-col cols="6">
                <b-form-group label="Barcode" label-for="mc-Barcode">
                  <b-form-input
                    id="mc-Barcode"
                    type="text"
                    v-model="product.barcode"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="mc-stock-threshold"
                  label="Unit Of Measure"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="mc-Barcode"
                      type="text"
                      :value="product.uomName"
                      readonly
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="mc-stock-threshold"
                  label="Low Stock Threshold"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="mc-stock"
                      type="text"
                      v-model="product.lowStock"
                      readonly
                    />
                  </div>
                </b-form-group>
              </b-col>
              <!--  <b-col md="6">
               <b-form-group label-for="batchqty" label="Batch Quantity">
                  <b-form-input
                    id="mc-Product-batchqty"
                    v-model="product.productionLimit"
                    readonly
                  />
                </b-form-group>
              </b-col> -->
              <b-col md="6">
                <b-form-group
                  label-for="productionCapacity"
                  label="Production Capacity"
                >
                  <b-form-input
                    id="mc-Product-productionCapacity"
                    v-model="product.productionLimit"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Category" label-for="mc-Category">
                  <b-form-input
                    id="mc-Category"
                    v-model="product.categoryName"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Sub Category" label-for="mc-subCategory">
                  <b-form-input
                    id="mc-subCategory"
                    :value="product.subCategoryName"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <label
                  v-b-tooltip.hover.focus.v-secondary
                  title="Note: Disabling a product means all current stock will be sent to scrap."
                  for="textarea-default"
                  >Enable/Disable Product
                </label>

                <b-form-checkbox
                  checked="true"
                  readonly
                  name="check-button"
                  v-model="product.isActive"
                  switch
                >
                  {{ product.isActive ? "Enabled" : "Disabled" }}
                </b-form-checkbox>
              </b-col>

              <b-col cols="12">
                <CustomFieldsDetails
                  :ReadOnlyFields="true"
                  :AdditionalFields="product.additionalFields"
                  :ModuleReference="'Product'"
                ></CustomFieldsDetails>
              </b-col>
              <b-col cols="12" class="mb-2">
                <label for="textarea-default">Product Description</label>
                <b-form-textarea
                  id="textarea-default"
                  value="Lorem"
                  rows="5"
                  v-model="product.description"
                  readonly
                />
              </b-col>
              <b-row class="row mb-2 col-12">
                <!-- Left: Product Image (half-width) -->
                <b-col md="6" v-if="product.productImage">
                  <b-form-group label="Product Image">
                    <div class="d-flex">
                      <img
                        :src="'data:image/jpeg;base64,' + product.productImage"
                        class="img-fluid"
                        width="250" height="250"
                        style="max-height: 130px; max-width: 100%; object-fit: contain;"
                        alt="Product Image"
                      />
                    </div>
                  </b-form-group>
                </b-col>
              
                <!-- Right: Barcode & Buttons (half-width) -->
                <b-col md="6" v-if="product.barcode">
                  <b-form-group label="Barcode Preview">
                    <div class="d-flex flex-column ">
                      <div ref="barcode" class="mb-2">
                        <barcode
                          :value="product.barcode"
                          format="CODE128"
                          class="canva"
                        >
                          Invalid barcode - Barcode cannot be rendered.
                        </barcode>
                      </div>
                      <div class="d-flex gap-2">
                        <b-button
                          @click="downloadBarcode"
                          variant="success"
                        >
                          Download Barcode
                        </b-button>
                        <b-button
                          @click="printBarcode"
                          variant="info"
                        >
                          Print Barcode
                        </b-button>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-row>
          </b-form>
        </tab-content>
        <!-- <tab-content title="Reorder Criteria">
          <ViewProductReorderCriteria
            :productManufacturedInHouse="product.inHouseManufactured"
            :reorderingData="product.orderingInfo"
          />
        </tab-content> -->
        <tab-content title="Bill Of Materials">
          <b-form
            ref="form"
            :style="{ height: trHeight }"
            class="repeater-form"
            @submit.prevent="repeateAgain"
          >
            <!-- Row Loop -->
            <b-row v-for="(item, index) in sortBom" :id="index" :key="index">
              <b-col md="3">
                <b-form-group
                  label="Raw Material / Work In Progress"
                  label-for="Operation-name"
                >
                  <b-form-input
                    :value="getMaterialNameById(item.materialId)"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Unit of Measure" label-for="cost">
                  <b-form-input
                    :value="getUomNameById(item.itemUomId)"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Qty" label-for="cost">
                  <b-form-input
                    id="cost"
                    type="number"
                    v-model="item.quantity"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <!-- Profession -->
              <b-col lg="2" md="2">
                <b-form-group label="Total Cost" label-for="price">
                  <b-form-input id="price" v-model="item.totalCost" readonly />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>
            </b-row>
          </b-form>
        </tab-content>
        <!-- Operation Steps Tab -->

        <tab-content title="Pricing">
          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Cost Price"
                  label-for="h-number"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-if="HasPermission(PermissionList.Inventory_Finance)"
                    id="h-number"
                    type="number"
                    v-model="product.purchasePrice"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="Selling Price (Tax Exclusive)"
                  label-for="h-Selling"
                  label-cols-md="4"
                >
                  <b-form-input
                    id="h-Mark"
                    type="number"
                    v-model="product.salePrice"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="vat">
                <b-form-group
                  label="Sales VAT (%)"
                  label-for="h-Tax"
                  label-cols-md="4"
                >
                  <b-form-input
                    id="h-Mark"
                    type="number"
                    v-model="product.saleTaxPercentage"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Percentage Mark Up (%)"
                  label-for="h-password"
                  label-cols-md="4"
                >
                  <b-form-input
                    id="h-Mark"
                    type="number"
                    v-model="product.markUpPercentage"
                    readonly
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </tab-content>
      </form-wizard>
      <form-wizard
        color="#B1D06C"
        :title="null"
        :subtitle="null"
        shape="square"
        finish-button-text="Finish"
        back-button-text="Previous"
        class="mb-3"
        @on-complete="formSubmitted"
        ref="formWiz"
        v-if="
          product.inHouseManufactured === null ||
          product.inHouseManufactured == false
        "
      >
        <!-- Search details tab -->
        <tab-content title="Details">
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group label="Product Name" label-for="mc-Product-name">
                  <b-form-input
                    id="mc-Product-name"
                    type="text"
                    v-model="product.name"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Product classification"
                  label-for="mc-Product-name"
                >
                  <b-form-input
                    id="mc-Product-name"
                    type="text"
                    :value="getTypeNameById(product.type)"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Product Code" label-for="mc-Product-Code">
                  <b-form-input
                    id="mc-Product-Code"
                    type="text"
                    v-model="product.code"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Barcode" label-for="mc-Barcode">
                  <b-form-input
                    id="mc-Barcode"
                    type="text"
                    v-model="product.barcode"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="mc-stock-threshold"
                  label="Unit Of Measure"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="mc-Barcode"
                      type="text"
                      :value="product.uomName"
                      readonly
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="mc-stock-threshold"
                  label="Low Stock Threshold"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="mc-stock"
                      type="text"
                      v-model="product.lowStock"
                      readonly
                    />
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group label="Category" label-for="mc-Category">
                  <b-form-input
                    id="mc-Category"
                    v-model="product.categoryName"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group label="Sub Category" label-for="mc-subCategory">
                  <b-form-input
                    id="mc-subCategory"
                    :value="product.subCategoryName"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Preferred Supplier"
                  label-for="mc-Supplier"
                >
                  <b-form-input
                    id="mc-Supplier"
                    type="text"
                    :value="getSupplierNameById(product.supplierId)"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <label for="check-button">Product Status</label>
                <b-form-checkbox
                  checked="true"
                  name="check-button"
                  v-model="product.isActive"
                  switch
                  :disabled="true"
                >
                  {{ product.isActive ? "Enabled" : "Disabled" }}
                </b-form-checkbox>
              </b-col>

              <b-col cols="12">
                <CustomFieldsDetails
                  :ReadOnlyFields="true"
                  :AdditionalFields="product.additionalFields"
                  :ModuleReference="'Product'"
                ></CustomFieldsDetails>
              </b-col>
              <b-col cols="12" class="mb-2">
                <label for="textarea-default">Product Description</label>
                <b-form-textarea
                  id="textarea-default"
                  value="Lorem"
                  rows="5"
                  v-model="product.description"
                  readonly
                />
              </b-col>

              <b-row class="col-12">

                <div class="col-6">
                  <b-col cols="12" v-if="product.productImage">
                    <b-form-group label="Product Image">
                      <img
                        :src="'data:image/jpeg;base64,' + product.productImage" width="250" height="250"
                      />
                    </b-form-group>
                  </b-col>
                </div>
                <div class="col-6">
                  <b-col v-if="product.barcode">
                    <b-row>
                      <b-col
                        class="d-flex justify-content-center align-items-center"
                        ref="barcode"
                      >
                        <barcode
                          :value="product.barcode"
                          format="CODE128"
                          class="canva"
                        >
                          Invalid barcode - Barcode cannot be rendered.
                        </barcode>
                      </b-col>
                      <b-col class="d-flex flex-column justify-content-between">
                        <b-button
                          @click="downloadBarcode"
                          variant="success"
                          class="w-50"
                          >Download Barcode</b-button
                        >
                        <b-button
                          @click="printBarcode"
                          variant="info"
                          class="w-50"
                          >Print Barcode</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </div>

                
              </b-row>
            </b-row>
          </b-form>
        </tab-content>
        <!-- <tab-content title="Reorder Criteria">
          <ViewProductReorderCriteria
            :productManufacturedInHouse="product.inHouseManufactured"
            :reorderingData="product.orderingInfo"
          />
        </tab-content> -->
        <tab-content title="Pricing">
          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Cost Price"
                  label-for="h-number"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-if="HasPermission(PermissionList.Inventory_Finance)"
                    id="h-number"
                    type="number"
                    v-model="product.purchasePrice"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Selling Price (Tax Exclusive)"
                  label-for="h-Selling"
                  label-cols-md="4"
                >
                  <b-form-input
                    id="h-Mark"
                    type="number"
                    v-model="product.salePrice"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Sales Tax"
                  label-for="h-Tax"
                  label-cols-md="4"
                >
                  <b-form-input
                    id="h-Mark"
                    type="number"
                    v-model="product.saleTaxPercentage"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="Percentage Mark Up (%)"
                  label-for="h-password"
                  label-cols-md="4"
                >
                  <b-form-input
                    id="h-Mark"
                    type="number"
                    v-model="product.markUpPercentage"
                    readonly
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import ConfirmProduct from "@/views/inventory/products/AddProduct/ConfirmProduct.vue";
import AddProduct from "@/views/inventory/products/AddProduct/addproduct.vue";
import buildprocess from "@/views/inventory/products/AddProduct/buildprocess.vue";
import AddProductBuy from "@/views/inventory/products/AddProduct/AddProductBuy.vue";
import OtherCosts from "@/views/inventory/products/AddProduct/OtherCosts.vue";
import AddBOM from "@/views/inventory/products/AddProduct/AddBOM.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { heightTransition } from "@core/mixins/ui/transition";
import { mapActions, mapGetters } from "vuex";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import {
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BContainer,
  BCard,
  BSpinner,
  BForm,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
  BFormFile,
  BFormDatepicker,
  BCardText,
  VBTooltip,
} from "bootstrap-vue";
import { codeIcon } from "@/views/inventory/products/AddProduct/LeadsWizard.js";
import VueBarcode from "vue-barcode";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";

export default {
  components: {
    FormWizard,
    BContainer,
    buildprocess,
    AddBOM,
    BButton,
    BFormCheckbox,
    BSpinner,
    BCard,
    TabContent,
    BRow,
    OtherCosts,
    AddProduct,
    BCol,
    AddProductBuy,
    ConfirmProduct,
    ToastificationContent,
    BForm,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BFormFile,
    BFormDatepicker,
    vSelect,
    barcode: VueBarcode,
    BCardText,
    CustomFieldsDetails,
    VBTooltip,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [heightTransition],
  data() {
    return {
      Product: null,
      id: this.$route.params.id,
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      codeIcon,
      loadingSpinner: true,
      barcodeValue: "6091188701814",
      productTypes: [
        { value: 1, text: "Finished" },
        { value: 2, text: "Semi Finished" },
        { value: 3, text: "Raw Material" },
        { value: 4, text: "Service" },
      ],
      materials: [],
    };
  },

  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },

  methods: {
    //route pages to leads

    neckStep() {
      this.$refs.formWiz.nextTab();
    },
    formSubmitted() {
      this.$router.push({ name: "product-list" });
      this.$bvModal.hide("modal-1");
    },
    ...mapActions("productModule", [
      "getProductIDAction",
      "getProductListAction",
    ]),
    ...mapActions("rawmaterialModule", ["getRawMaterialListAction"]),
    ...mapActions("itemUomModule", ["getItemUOMListAction"]),
    ...mapActions("itemcategoryModule", ["getItemCategoryListAction"]),
    ...mapActions("supplierModule", ["getSupplierListAction"]),
    ...mapActions("labourModule", ["getLabourListAction"]),
    ...mapActions("equipmentModule", ["getEquipmentListAction"]),
    async downloadBarcode() {
      try {
        await this.$nextTick();

        // Make sure you are accessing the correct element
        const barcodeElement = document.getElementsByClassName("canva")[0];
        if (!barcodeElement) {
          console.error("Barcode element is not available.");
          alert("Barcode cannot be downloaded at this time.");
          return;
        }

        const barcodeSvg = barcodeElement.querySelector("svg");
        if (!barcodeSvg) {
          console.error("SVG element is not available.");
          alert("Barcode cannot be downloaded at this time.");
          return;
        }

        // Serialize SVG XML to a string.
        const serializer = new XMLSerializer();
        const svgStr = serializer.serializeToString(barcodeSvg);

        // Create a canvas element to convert SVG to PNG
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const svg = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(svg);

        const image = new Image();
        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          URL.revokeObjectURL(url);

          const pngUrl = canvas.toDataURL("image/png");

          // Create and click the download link
          const link = document.createElement("a");
          link.href = pngUrl;
          link.download = "barcode.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };
        image.src = url;
      } catch (error) {
        console.error("An error occurred during barcode download:", error);
      }
    },

    printBarcode() {
      this.$nextTick(() => {
        const barcodeElement = document.getElementsByClassName("canva")[0];
        const barcodeSvg = barcodeElement.querySelector("svg");
        if (!barcodeSvg) {
          console.error("SVG element is not available.");
          alert("Barcode cannot be downloaded at this time.");
          return;
        }

        const serializer = new XMLSerializer();
        const svgStr = serializer.serializeToString(barcodeSvg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const DOMURL = window.URL || window.webkitURL || window;

        let img = new Image();
        let svg = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
        let url = DOMURL.createObjectURL(svg);

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          DOMURL.revokeObjectURL(url);

          const pngUrl = canvas.toDataURL("image/png");

          // Open print window and modify its content and title
          let printWindow = window.open("", "PRINT", "height=600,width=800");
          printWindow.document.write(
            `<html><head><title>Print Barcode</title></head><body style="margin: 0; padding: 0; display: flex; justify-content: center; align-items: center;"><img src="${pngUrl}" onload="window.print();window.close()"></body></html>`
          );
          printWindow.document.close();
          printWindow.focus();
        };

        img.src = url;
      });
    },

    getTypeNameById(id) {
      let type = this.productTypes.filter((obj) => {
        return obj.value === id;
      });
      if (type.length > 0) {
        return type[0].text;
      }
      return null;
    },
    getUomNameById(id) {
      let uom = this.itemUoms.filter((obj) => {
        return obj.id === id;
      });
      if (uom.length > 0) {
        return uom[0].name;
      }
      return null;
    },
    getSupplierNameById(id) {
      let supplier = this.suppliers.filter((obj) => {
        return obj.id === id;
      });
      if (supplier.length > 0) {
        return supplier[0].name;
      }
      return null;
    },
    getLabourNameById(id) {
      let labour = this.labours.filter((obj) => {
        return obj.id === id;
      });
      if (labour.length > 0) {
        return labour[0].labourName;
      }
      return null;
    },
    getEquipmentNameById(id) {
      let equipment = this.equipments.filter((obj) => {
        return obj.id === id;
      });
      if (equipment.length > 0) {
        return equipment[0].name;
      }
      return null;
    },
    getDirectCost(item) {
      return (
        item.labourCost * item.cycles * item.cycleHours +
        item.equipmentCost * item.cycles * item.cycleHours
      );
    },
    getMaterialCost(item) {
      let material = this.rawmaterials.filter((obj) => {
        return obj.id === item.materialId;
      });
      if (material.length > 0) {
        let cost =
          (material[0].purchasePrice ?? 0) == 0
            ? material[0].salePrice ?? 0
            : material[0].purchasePrice ?? 0;
        return (item.quantity ?? 0) * cost;
      }
    },
    getMaterialNameById(id) {
      let material = this.materials.filter((obj) => obj.id === id);

      console.log("mat", material, this.rawmaterials);
      if (material.length > 0) {
        return material[0].name;
      }
      return null;
    },
  },
  async mounted() {
    setTimeout(() => {
      this.loadingSpinner = false;
    }, 5000);

    await this.getProductIDAction(this.id)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        this.product = [];
        // alert(error.message);
        this.$swal({
          title: "Error!",
          html: error.message,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      });

    await this.getItemUOMListAction();
    await this.getItemCategoryListAction();
    await this.getSupplierListAction();
    await this.getLabourListAction();
    await this.getEquipmentListAction();
    await this.getRawMaterialListAction().then(() => {
      this.rawmaterials.map((x) => {
        if (x.defaultUomID) {
          this.materials.push({
            id: x.id,
            name: x.name,
            defaultUomID: x.defaultUomID,
            salesPrice: x.salesPrice,
            purchasePrice: x.purchasePrice,
          });
        }
      });
    });

    await this.getProductListAction().then(() => {
      this.products.map((x) => {
        if (x.defaultUomId && x.type === 2) {
          this.materials.push({
            id: x.id,
            name: x.name,
            defaultUomID: x.defaultUomId,
            salesPrice: x.salesPrice,
            purchasePrice: x.purchasePrice,
          });
        }
      });
    });
  },
  computed: {
    sortedOperationSteps: function () {
      function compare(a, b) {
        if (a.itemOperationOrder < b.itemOperationOrder) return -1;
        if (a.itemOperationOrder > b.itemOperationOrder) return 1;
        return 0;
      }

      return this.product.operationSteps.sort(compare);
    },
    sortBom: function () {
      function compare(a, b) {
        if (a.itemBOMOrder < b.itemBOMOrder) return -1;
        if (a.itemBOMOrder > b.itemBOMOrder) return 1;
        return 0;
      }
      return this.product.billOfMaterials.sort(compare);
    },
    ...mapGetters("productModule", {
      product: "productID",
      products: "product",
      loading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      rawmaterials: "rawmaterials",
      loading: "loading",
    }),
    getImageUrl() {
      const imageType = this.product.productImageName.split(".").pop();
      const dataUrlPrefix = `data:image/${imageType};base64,`;
      const imageUrl = dataUrlPrefix + this.product.productImage;

      return imageUrl;
    },
    ...mapGetters("itemUomModule", {
      itemUoms: "itemuom",
      loading: "loading",
    }),
    ...mapGetters("itemcategoryModule", {
      itemCategories: "itemcategories",
      loading: "loading",
    }),
    ...mapGetters("supplierModule", {
      suppliers: "suppliers",
      loading: "loading",
    }),
    ...mapGetters("labourModule", {
      labours: "labour",
      loading: "loading",
    }),
    ...mapGetters("equipmentModule", {
      equipments: "equipments",
      loading: "loading",
    }),
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style scoped>
label {
  font-size: 1.714rem !important;
  font-weight: 500;
  margin-bottom: 0;
}
</style>
